import * as yup from "yup";
import i18n from "~/i18n";

export const MoveCopyToProjectFormValidator = yup.object().shape({
  project_id: yup.number().required(i18n.t("Project missing")),
  leave: yup.boolean(),
});
